import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import AddTemplateToEvent from '../../Modals/ConfirmationEmail/AddTemplateToEvent'
import { creationEventStore } from 'state/event/eventCreationStore'

const ConfirmationEmail: React.FC = () => {
  const [openEmailModal, setOpenEmailModal] = useState<boolean>(false)
  const eventData = creationEventStore(store => store.eventData)
  return (
    <>
      <div onClick={() => setOpenEmailModal(true)}>
        <IconsTextNavigation
          iconName="EnvelopeSimple"
          heading="Scheduled email"
          isCompleted={eventData?.emailTemplates.length}
        />
      </div>
      {openEmailModal && (
        <AddTemplateToEvent
          openModal={openEmailModal}
          closeModal={setOpenEmailModal}
        />
      )}
    </>
  )
}

export default ConfirmationEmail
